<template>
  <div class="navigation-sidebar text-sm">
    <v-link :anchor="href" class="navigation-sidebar-enter uppercase">{{
      dic.userEnter
    }}</v-link>

    <div class="navigation-sidebar-contacts">
      <v-link anchor="tel:+380443948504">{{ tel }}</v-link>
      <br />
      <v-link anchor="#footer" class="uppercase"
        >{{ dic.contacts }} {{ dic.brand }}</v-link
      >
    </div>
  </div>
</template>

<script>
import VLink from '@/components/ui/VLink'
import { HEADER_TEL_NUM } from '@/libs/constants'

export default {
  data() {
    return {
      href: 'https://sovtes.ua/a/index.php?p=login',
      tel: HEADER_TEL_NUM,
    }
  },
  computed: {
    currentLang() {
      //this need for wake up store listner
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner
      return this.$store.state.main.dic
    },
  },
  components: {
    VLink,
  },
}
</script>

<style scoped lang="scss">
.navigation-sidebar {
  font-weight: 100;
  line-height: 2.2;

  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;

  min-width: 210px;

  & > a {
    padding: 5px 20px;
    text-decoration: none;
  }

  & > a:nth-child(1) {
    background: #facb0a;
  }

  & > a:nth-child(1):visited {
    color: black;
  }

  & > a:nth-child(2):visited {
    color: #e4e8ec;
  }
}

.navigation-sidebar-contacts {
  box-sizing: border-box;
  padding: 5px 20px;
  background: #021759;
  color: #e4e8ec;
  display: inline-block;

  & > a:link {
    color: #e4e8ec;
  }
  & > a:visited {
    color: #e4e8ec;
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
}

@media (max-width: 435px) {
  .navigation-sidebar {
    min-width: 0px;
    & > a {
      padding: 5px 12px;
    }
  }

  .navigation-sidebar-contacts {
    padding: 5px 12px;
  }
}

@media (max-width: 375px), (max-width: 414px) {
  .navigation-sidebar {
    min-width: 0px;
    & > a {
      padding: 5px 10px;
    }
  }

  .navigation-sidebar-contacts {
    padding: 5px 10px;
  }
}
</style>
